<template>
  <div class="main">
    <header id="header">
      <div class="logo-wrap">
        <img @click="clickLogo" class="logo" :src="require('../assets/logo_default.svg')"/>
        <img @click="clickLogo" class="logo" :src="require('../assets/addlogo.svg')"/>
      </div>
      <nav class="nav">
        <ul @click="toggleRoute">
          <li>
            <a name="home">首页</a>
            <div v-if="activeRoute==='home'" class="active"></div>
          </li>
          <li>
            <a name="product">产品</a>
            <div v-if="activeRoute==='product'" class="active"></div>
          </li>
          <li>
            <a name="solution">解决方案</a>
            <div v-if="activeRoute==='solution'" class="active"></div>
          </li>
          <li>
            <a name="download">下载</a>
            <div v-if="activeRoute==='download'" class="active"></div>
          </li>
          <li>
            <a name="aboutus">关于我们</a>
            <div v-if="activeRoute==='aboutus'" class="active"></div>
          </li>
        </ul>
        <el-dropdown class="dropdown-style" >
          <el-button type="primary">
            国恒充电<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="goToContent(1)">国恒充电</el-dropdown-item>
            <el-dropdown-item @click.native="goToContent(2)">星络充电</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </nav>
    </header>
    <div class="main-container">
      <router-view class="routes"></router-view>
      <footer>
        <div>
          <section class="left">
            <p class="name">国恒智慧能源服务有限公司</p>
            <p class="addr">广东省深圳市南山区南海大道和登良路交汇处南海大道2168号恒大天璟B区24楼</p>
          </section>
          <section class="middle">
            <p class="con">联系我们</p>
            <p>服务热线：400-600-2888</p>
            <p>服务时间：周一至周五8:30-17:30</p>
            <p class="ip">版权所有 © 国恒智慧能源服务有限公司</p>
            <p>
              <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备19105313号-1</a>
            </p>
            <p>
              <img style="width:20px; margin-right:10px;vertical-align: middle;" :src="require('../assets/icp.png')" alt="">
              <a style="vertical-align: sub;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009597" target="_blank">
                粤公网安备 44030502009597号
              </a>
            </p>
          </section>
          <div class="qrcode">
            <img  :src="require('../assets/qrcode.png')"/>
            <p>扫码下载APP</p>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Dropdown } from 'element-ui'
Vue.use(Dropdown)
export default {
  name: 'Main',
  provide: () => {
    return {
      is1920: window.screen.width <= 1920
    }
  },
  data () {
    return {
      activeRoute: 'home'
    }
  },
  mounted () {
    this.activeRoute = this.setActiveRoute(this.$route.name)
  },
  methods: {
    toggleRoute (e) {
      const name = e.target.name
      this.$router.push({ name })
    },
    goToContent (type) {
      if (type === 1) {
        location.reload()
      } else if (type === 2) {
        window.open('https://guoheng.com.cn:459/')
      }
    },
    clickLogo () {
      this.activeRoute = 'home'
      this.$router.push({ name: 'home' })
    },
    setActiveRoute (item) {
      const map = { home: 'home', guide: 'aboutus', serviceSupport: 'aboutus', product: 'product', productBox: 'product', productPile: 'product', productPile1: 'product', solution: 'solution', download: 'download', aboutus: 'aboutus' }
      return map[item]
    }
  },
  watch: {
    '$route.name' (val) {
      this.activeRoute = this.setActiveRoute(val)
    }
  }
}
</script>
<style lang="less">
.main{
  width: 100%;
  margin: 0 auto;
  // overflow: hidden;
  background-color: #f9f9f9;
  p{
    margin: 0;
  }
  header{
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    .logo{
      cursor: pointer;
      width: 2.16rem;
      height: .66rem;
    }
    width: 100%;
    min-width: 1030px;
    height: 1.20rem;
    min-height: 100px;
    background: white;
    padding: .30rem 0.6rem .30rem 0.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    nav {
      display: flex;
      align-items: center;
      .dropdown-style {
        margin-left: .4rem;
      }
    }
    nav > ul{
      margin: 0;
      display: flex;
      & > li{
        position: relative;
        cursor: pointer;
        margin-left: .4rem;
        font-size: .28rem;
        line-height: .40rem;
        padding-top: .12rem;
        white-space: nowrap;
        z-index: 1;
        .active{
          margin: 0 auto;
          background: #13E4E8;
          width: .48rem;
          height: .06rem;
          border-radius: 7.5px;
        }
      }
    }
  }
  .logo-wrap {
    display: flex;
  }
  .main-container{
    margin-top: 1.2rem;
    min-width: 1030px;
  }
  footer{
    width: 100%;
    background: #2b2d33;
    padding: 0.4rem 0 0.2rem;
    >div{
      width: 12rem;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
    }
    .qrcode{
      flex: 0 0 .90rem;
      img{
        display: block;
        width: .90rem;
        height: .90rem;
        transform: scale(.9)
      }
      p{
        opacity: 0.6;
        font-size: .14rem;
        line-height: 20px;
        color: #FFF;
      }
    }
    .left{
      flex: 0 0 3.15rem;
      color: #FFF;
      text-align: left;
      .name{
        font-size: .20rem;
        line-height: 28px;
        margin: 0 0 .10rem;
      }
      .addr{
        opacity: .6;
        font-size: .14rem;
        line-height: 20px;
      }
    }
    .middle{
      // margin: 0 2.5rem 0 1.78rem;
      flex: 0 0 4.25rem;
      p{
        opacity: 0.6;
        font-size: .14rem;
        line-height: 20px;
        color: #FFFFFF;
        text-align: left;
        &.con{
          opacity: 1;
          font-size: .18rem;
          margin:0 0 .15rem;
        }
        &.ip{
          line-height: 20px;
          margin: .24rem 0 0;
        }
      }
    }
  }
}
</style>
